import React, { useState } from "react";
import { Switch } from "antd";
import { Card } from "react-bootstrap";

const LightsSwitch = () => {
  const [value, setValue] = useState(false);

  return (
    <div>
      <Card>
        <Card.Header>Scooter lights</Card.Header>
        <Card.Body className="text-center">
          <Switch
            checkedChildren="Enabled"
            unCheckedChildren="Disabled"
            onChange={newValue => setValue(newValue)}
            checked={value}
          />
        </Card.Body>
      </Card>
    </div>
  );
};

export default LightsSwitch;



// WEBPACK FOOTER //
// ./src/views/pages/scooter/dashboard/LightsSwitch/index.js